import ColumnHeader from 'Components/UI/Table/ColumnHeader';
import { Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { datetimeToString, formatDateByTime } from 'Utils/DateUtils';
import { getOrderTitle } from './Notification.helpers';
import {
  INotificationOrder,
  INotificationOrderKey
} from 'Store/Notification/interfaces/INotificationState';
import { GetAvatar } from 'Utils/generateThumbnail';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import {
  IContent,
  INotification,
  NotificationContentTypeEnum,
  NotificationSourceEnum
} from 'Data/interfaces/Notification/INotification';
import { processMessage } from 'Utils/HtmlUtils';
import { objContent } from 'Components/ShellHost/TopBar/NotificationList/components/Content/components/Card/content';
import { IMDTheme } from 'Data/interfaces/MultiDomain/IMDTheme';
import { Icon } from 'Components/UI';
import { loadImage } from 'Utils/MultidomailUtils';
import SpinCustom from 'Components/UI/SpinCustom';
import {
  DateRow,
  ActionRow,
  UserRow,
  ContentRow,
  ReadRow,
  LogoCoodly
} from './styles';

interface IColumns {
  obrasMap: Record<number, IObraResponse>;
  order: INotificationOrder;
  theme: IMDTheme;
  readingNotificationIds: string[];
  readNotificationLoading: boolean;
  onOrder: (key: INotificationOrderKey) => void;
  onRead: (item: INotification) => void;
  onRedirect: (item: INotification) => void;
}

export const tableColumns: (input: IColumns) => Array<ColumnProps<INotification>> = ({
  obrasMap,
  order,
  theme,
  readingNotificationIds,
  readNotificationLoading,
  onOrder,
  onRead,
  onRedirect,
}) => [
    {
      dataIndex: 'Message',
      width: 'auto',
      title: (
        <ColumnHeader
          title="Ação"
          sorter={() => {
            onOrder('notifications');
          }}
          orderTooltip={getOrderTitle(order.notifications, 'notifications')}
        />
      ),
      render: (_value, record: INotification) => {
        return (
          <ActionRow onClick={() => onRedirect(record)}>
            {record.Source === NotificationSourceEnum.System && (
              <LogoCoodly
                src={loadImage('icon-logo-white.svg')}
                alt="Logo Coodly"
              />
            )}
            {record.Source === NotificationSourceEnum.User && (
              <GetAvatar
                name={record?.CreatedByUser?.Nome || ''}
                src={record?.CreatedByUser?.ThumbnailImageUrl || record?.CreatedByUser?.OriginalImageUrl || ''}
                size={24}
                fontSize={12}
              />
            )}
            <span className="actionMessage">
              {processMessage(record.Message)}
            </span>
          </ActionRow>
        )
      },
    },
    {
      dataIndex: 'Content',
      width: 300,
      title: <ColumnHeader title="" showOrder={false} />,
      render: (_value, record) => {
        const firstIndex = record.Content.findIndex(content => {
          return content.Type === NotificationContentTypeEnum.ref;
        });
        if (
          firstIndex !== -1 &&
          record?.AggNotificationIds &&
          record.AggNotificationIds?.length > 0
        ) {
          record.Content[firstIndex].aggIds = record.AggNotificationIds;
        }

        return (
          <ContentRow onClick={() => onRedirect(record)}>
            {record.Content.map((contentItem: IContent) => (
              objContent[contentItem.Type]({
                content: contentItem.ContentItems,
                className: contentItem.Class,
                theme: theme.colors,
                aggIds: contentItem.aggIds,
              })
            ))}
          </ContentRow>
        )
      },
    },
    {
      dataIndex: 'ConstructionSiteFk',
      width: 270,
      title: <ColumnHeader title="Obra" showOrder={false} />,
      render: (_value, record) => {
        const obra = obrasMap[record.ConstructionSiteFk];
        return (
          <UserRow>
            <GetAvatar
              name={obra?.Name}
              thumbSrc={obra?.ThumbnailImageUrl}
              src={obra?.OriginalImageUrl}
              shape='circle'
              size='small'
            />
            <Tooltip title={obra?.Name}>
              <p>{obra?.Name}</p>
            </Tooltip>
          </UserRow>
        )
      },
    },
    {
      dataIndex: 'CreationDate',
      width: 180,
      title: (
        <ColumnHeader
          title="Data"
          sorter={() => {
            onOrder('data');
          }}
          orderTooltip={getOrderTitle(order.data, 'data')}
        />
      ),
      render: (value: string) => {
        const convertedDate = new Date(value);
        return (
          <Tooltip title={datetimeToString(convertedDate)}>
            <DateRow>
              <p>{formatDateByTime(convertedDate)}</p>
            </DateRow>
          </Tooltip>
        )
      },
    },
    {
      dataIndex: 'IsRead',
      width: 40,
      title: <ColumnHeader title="" showOrder={false} />,
      render: (value: boolean, record: INotification) => {
        if (value) return null;

        const isLoading = readNotificationLoading && readingNotificationIds.includes(record.NotificationId);

        return (
          <ReadRow>
            <div className="notificationBadge" />
            <div
              className="readSpan"
              onClick={() => onRead(record)}
            >
              {isLoading ? (
                <SpinCustom
                  size={10}
                  color={theme.colors.surface.onSurfaceVariant}
                  marginRigth={4}
                />
              ) : (
                <Icon
                  icon="readNotification"
                  customSize={16}
                  className="iconReadNotification"
                />
              )}
            </div>
          </ReadRow>
        )
      },
    },
  ];
